'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _tableLocal = require('./table.local.css');

var _tableLocal2 = _interopRequireDefault(_tableLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TableCell = function TableCell(_ref) {
  var field = _ref.field,
      sortColumn = _ref.sortColumn,
      children = _ref.children,
      className = _ref.className;
  return _react2.default.createElement('td', {
    className: (0, _classnames2.default)([_tableLocal2.default.cell, field === sortColumn.field && _tableLocal2.default.activeCell, className])
  }, _react2.default.createElement('div', {
    className: (0, _classnames2.default)([_tableLocal2.default.value])
  }, children));
};

TableCell.propTypes = {
  /**
   * sort column shape of field: string, order: string
   */
  sortColumn: _propTypes2.default.shape({
    field: _propTypes2.default.string.isRequired,
    order: _propTypes2.default.string.isRequired
  }).isRequired,

  /**
   * Field this cell relates to
   */
  field: _propTypes2.default.string.isRequired,

  /**
   * Node to render within the tbody
   */
  children: _propTypes2.default.node.isRequired,

  /**
   * Classname to apply to the tbody node
   */
  className: _propTypes2.default.string
};
exports.default = TableCell;